import React, { useEffect } from 'react';

import { publish } from '@pkg/components/Sections/Profile/pubSub';
import {
    glLiquidIdExpandedPreview,
    glLiquidIDOrbitControls,
    glLiquidIDRotate,
} from '@pkg/components/Sections/Profile/pubSub/constants';
import { useAppSelector } from '@pkg/hooks';
import { useMediaQuery } from '@pkg/providers';

import PrototypeLiquidIDSection from '../../../Prototype/LiquidIDSection';

const LiquidIDSection = () => {
    const { desktop } = useMediaQuery();
    const { liquidIDExpandedPreview } = useAppSelector((state) => state.yatPage);

    useEffect(() => {
        // If touch device - only expanded preview can orbit cube, else all states but editing liquid id
        publish(glLiquidIDOrbitControls, true);
        publish(glLiquidIDRotate, true);
        publish(glLiquidIdExpandedPreview, liquidIDExpandedPreview);
    }, [liquidIDExpandedPreview, desktop]);

    return <PrototypeLiquidIDSection />;
};

export default LiquidIDSection;
